import React from "react";

const UpdateSummary = ({ setCurrentStep, billingCycle }) => {
  return (
    <div className="max-w-4xl mx-auto p-6 md:p-8 bg-white rounded-2xl shadow-lg border border-gray-100">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          Order Summary
        </h2>
        <p className="text-gray-600">
          Review your selected plan before proceeding to payment.
        </p>
      </div>

      {/* --- NEW: Warning Message for Previous Plan --- */}
      <div className="mb-8 p-4 bg-yellow-50 border border-yellow-200 text-yellow-800 rounded-lg flex items-start shadow-sm">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 flex-shrink-0 mt-0.5 mr-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.342a.879.879 0 011.486 0l3.41 6.829a1 1 0 01-.17 1.096L10.375 14a1 1 0 01-1.75 0l-2.522-3.733a1 1 0 01-.17-1.096l3.41-6.829zM10 2a.999.999 0 00-1.724-.62L4.605 9.208A1.996 1.996 0 005.908 12.1l2.522 3.733A.998.998 0 009.25 16h1.5A.998.998 0 0011.52 15.833l2.522-3.733a1.996 1.996 0 001.303-2.892L11.724 1.38A.999.999 0 0010 2z"
            clipRule="evenodd"
          />
        </svg>
        <p className="text-sm font-medium">
          **Important:** This action will replace your previous subscription
          plan. Any subscription fees already paid will not be refunded.
        </p>
      </div>
      {/* --- END NEW WARNING MESSAGE --- */}

      <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-200 mb-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-3">
          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-1">
              Membership Plan
            </h3>
            <div className="inline-block bg-red-100 text-red-700 font-bold rounded-full px-4 py-1 text-sm uppercase tracking-wide">
              {billingCycle.tiers || "-"}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="bg-gray-100 rounded-lg px-3 py-1 text-sm font-medium">
              {billingCycle.freq === "monthly"
                ? "Monthly Billing"
                : "Annual Billing"}
            </div>
            {billingCycle.freq === "yearly" && (
              <div className="bg-green-100 text-green-700 rounded-lg px-3 py-1 text-sm font-medium">
                Save 20%
              </div>
            )}
          </div>
        </div>

        <div className="space-y-4 border-t border-gray-200 pt-6">
          <div className="flex justify-between items-center">
            <div>
              <h4 className="font-medium text-gray-700">Base Plan</h4>
              <p className="text-sm text-gray-500 p-0 mb-0">
                {billingCycle.freq === "monthly"
                  ? "Monthly subscription"
                  : "Annual subscription (12 months)"}
              </p>
            </div>
            <span className="font-medium text-gray-800">
              ${billingCycle.value?.price?.toFixed(2)}
            </span>
          </div>

          <div className="flex justify-between items-center pt-4 border-t border-gray-100">
            <div>
              <h4 className="font-medium text-gray-700">Billing Cycle</h4>
              <p className="text-sm text-gray-500 p-0">
                {billingCycle.freq === "monthly"
                  ? "Charged monthly"
                  : "Charged annually"}
              </p>
            </div>
            <span className="text-sm text-gray-600">
              {billingCycle.freq === "monthly" ? "Per month" : "Per year"}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-200 mb-8">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-700">Total Amount</h3>
          <div className="text-right">
            <div className="text-2xl font-bold text-gray-900">
              ${billingCycle.value?.price?.toFixed(2)}
            </div>
            <p className="text-sm text-gray-500 p-0 mb-0">
              {billingCycle.freq === "monthly"
                ? "Billed monthly"
                : "Billed annually"}
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 justify-between mt-10 pt-6 border-t border-gray-200">
        <button
          className="px-6 py-3.5 bg-white text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition shadow-sm w-full sm:w-auto"
          onClick={() => setCurrentStep(1)}
        >
          Back to Plans
        </button>
        <button
          className="px-6 py-3.5 bg-gradient-to-r from-red-600 to-red-700 text-white font-medium rounded-lg hover:from-red-700 hover:to-red-800 transition shadow-md w-full sm:w-auto"
          onClick={() => setCurrentStep(3)}
        >
          Continue to Payment
        </button>
      </div>
    </div>
  );
};

export default UpdateSummary;
